module.exports = __webpack_public_path__ + "static/bg.c05940d3.png";